(() => {
  'use strict';
  const config = document.getElementById('tdt-company-reviews-config');
  if (!config || document.getElementById('tdt-company-reviews-host')) return;
  const surfaceTargets = '.hs-rating, .hs-fan-rating, .tf-rating, [data-tdt-company-review]';
  if (config.dataset.page === 'page' && !document.querySelector(surfaceTargets)) return;
  const en = (document.documentElement.lang || 'de').toLowerCase().startsWith('en');
  const da = (document.documentElement.lang || '').toLowerCase().startsWith('da');
  const copy = da ? {read:'Læs anmeldelser',caption:'Koncertanmeldelser af Dark Tenor',reviews:'anmeldelser',close:'Luk anmeldelser'} : en ? {read:'Read reviews',caption:'Concert reviews for Dark Tenor concerts',reviews:'reviews',close:'Close reviews'} : {read:'Bewertungen lesen',caption:'Fanreports zu Dark Tenor Konzerten',reviews:'Bewertungen',close:'Bewertungen schließen'};
  const host = document.createElement('div');
  host.id = 'tdt-company-reviews-host';
  host.innerHTML = '<div class="tdt-reviews-backdrop" hidden></div><div class="reviews-io-floating-widget" widget-id="s7Xb3EHYF10AwjVN" data-store-name="dark-tenor" lang="'+(da?'da':en?'en':'de')+'"></div>';
  document.body.append(host);
  let score = '', count = '', wasOpen = false, opener = null, scheduled = false;
  function enhance() {
    scheduled = false;
    const panel = host.querySelector('.FloatingPanel');
    const numbers = panel && panel.querySelectorAll('.cssVar-subheading__number strong');
    if (numbers && numbers.length === 2) { score = numbers[0].textContent.trim(); count = numbers[1].textContent.trim(); }
    const targets = [...document.querySelectorAll('.tdt-cart .cart-trust, .tdt-ticket .opti2-rating, .tdt-ticket .tdt-ticket__rating, .tdt-review-trigger--hero, '+surfaceTargets)];
    if (!targets.length && ['concert','collection','landing','index'].includes(config.dataset.page)) {
      const heading = document.querySelector('#MainContent h1, #MainContent .section-header__title');
      const collectionMain = config.dataset.page === 'collection' && document.getElementById('MainContent');
      if (heading || collectionMain) {
        let slot = document.getElementById('tdt-company-review-slot');
        if (!slot) {
          slot = document.createElement('div');slot.id='tdt-company-review-slot';
          if (heading) heading.after(slot);
          else { slot.className='tdt-review-collection-fallback'; const firstSection=collectionMain.querySelector(':scope > .shopify-section'); if(firstSection)firstSection.after(slot);else collectionMain.prepend(slot); }
        }
        targets.push(slot);
      }
    }
    targets.forEach(target => {
      let control = target.matches('.tdt-review-trigger') ? target : target.querySelector('.tdt-review-trigger');
      if (!control) {
        control = document.createElement('button');control.type='button';control.className='tdt-review-trigger';control.setAttribute('aria-haspopup','dialog');
        if (target.tagName === 'A' || target.tagName === 'BUTTON') { control.classList.add(...target.classList); target.replaceWith(control); }
        else target.replaceChildren(control);
        control.addEventListener('click', () => { const launch=host.querySelector('.R-LauncherButton');if(launch){opener=control;launch.click();}else{window.open('https://www.reviews.io/company-reviews/store/dark-tenor','_blank','noopener');} });
      }
      if (target.matches(surfaceTargets) || config.dataset.page === 'collection' || config.dataset.page === 'landing' || config.dataset.page === 'index') control.classList.add('tdt-review-trigger--surface');
      const concert=control.closest('.tdt-ticket');
      const title=concert?.querySelector('.erlebnis-show-title');
      const reviewSlot=title?.querySelector('[data-tdt-review-slot]')||title;
      if(reviewSlot && control.parentElement!==reviewSlot){if(reviewSlot!==title)reviewSlot.replaceChildren(control);else reviewSlot.append(control);control.classList.add('tdt-review-trigger--hero');}
      const key = score+'|'+count;

      if (control.dataset.ratingKey !== key) {
        control.dataset.ratingKey=key;
        control.innerHTML = score && count ? '<span class="tdt-review-line"><span class="tdt-review-stars" aria-hidden="true">★★★★★</span><strong></strong><span class="tdt-review-count"></span></span><span class="tdt-review-caption"></span>' : '<span class="tdt-review-caption"></span>';
        if(score && count){control.querySelector('strong').textContent=score+' / 5';control.querySelector('.tdt-review-count').textContent=count+' '+copy.reviews;}
        control.querySelector('.tdt-review-caption').textContent=score?(concert?(da?'Fantastisk show':en?'Excellent show':'Exzellente Show'):copy.caption):copy.read;
      }
    });
    if(panel){
      panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');panel.setAttribute('aria-label',copy.caption);
      const header=panel.querySelector('.FloatingPanel__header');
      if(header && score && count){
        const nativeStars=header.querySelector('.header__content__inner > div:first-child .R-RatingStars');
        const row=header.querySelector('.header__content__inner');
        if(nativeStars && row){
          let summary=header.querySelector('.tdt-review-summary');
          if(!summary){summary=document.createElement('div');summary.className='tdt-review-summary';row.insertBefore(summary,row.lastElementChild);}
          const key=score+'|'+count;
          if(summary.dataset.ratingKey!==key){
            summary.dataset.ratingKey=key;
            const rating=document.createElement('div');rating.className='tdt-review-summary-rating';
            const stars=nativeStars.cloneNode(true);stars.setAttribute('aria-hidden','true');
            stars.querySelectorAll('[title]').forEach(node=>node.removeAttribute('title'));
            const value=document.createElement('strong');value.textContent=score;value.setAttribute('aria-label',score+' / 5');
            rating.append(stars,value);
            const reports=document.createElement('p');reports.className='tdt-review-summary-reports';
            reports.textContent=count+' '+(da?'fanberetninger fra Dark Tenor-koncerter':en?'fan reports from Dark Tenor concerts':'Fanreports zu Dark Tenor Konzerten');
            summary.replaceChildren(rating,reports);
          }
        }
      }
      filterReviews(panel);
      const close=panel.querySelector('.R-IconButton--close');if(close)close.setAttribute('aria-label',copy.close);
      const open=panel.classList.contains('isActive');
      if(open !== wasOpen){wasOpen=open;document.body.classList.toggle('tdt-reviews-open',open);host.querySelector('.tdt-reviews-backdrop').hidden=!open;panel.setAttribute('aria-hidden',String(!open));if(open){loadReviews(panel);if(close)close.focus();}else if(opener && opener.isConnected)opener.focus();}
    }
  }
  // Filter review cards only; the provider's aggregate rating/count stay untouched.
  function reviewRating(article) {
    const title = article.querySelector('.R-RatingStars__stars')?.getAttribute('title') || '';
    const match = title.match(/^\s*([0-5](?:[.,]\d+)?)\s*(?:Stars?|Sterne?)\s*$/i);
    return match ? Number(match[1].replace(',', '.')) : NaN;
  }
  function filterReviews(panel) {
    panel.querySelectorAll('[role="article"]').forEach(article => {
      const rating = reviewRating(article);
      const card = article.closest('.R-ContentCard') || article;
      const hidden = !Number.isFinite(rating) || rating < 3 || rating > 5;
      if (card.classList.contains('tdt-review-filtered') !== hidden) {
        card.classList.toggle('tdt-review-filtered', hidden);
      }
    });

  }
  const pagingCopy = da ? {more:'Indlæs flere anmeldelser',loading:'Indlæser anmeldelser …',retry:'Prøv igen',error:'Anmeldelserne kunne ikke indlæses. Prøv igen.',empty:'Der er endnu ingen anmeldelser at vise.',newest:'Nyeste først',imported:'Importeret anmeldelse',photo:'Foto fra anmeldelsen',loaded:'anmeldelser indlæst'} : en ? {more:'Load more reviews',loading:'Loading reviews …',retry:'Try again',error:'Reviews could not be loaded. Please try again.',empty:'No reviews to display yet.',newest:'Newest first',imported:'Imported review',photo:'Review photo',loaded:'reviews loaded'} : {more:'Weitere Bewertungen laden',loading:'Bewertungen werden geladen …',retry:'Erneut versuchen',error:'Die Bewertungen konnten nicht geladen werden. Bitte versuche es erneut.',empty:'Noch keine Bewertungen verfügbar.',newest:'Neueste zuerst',imported:'Importierte Bewertung',photo:'Foto zur Bewertung',loaded:'Bewertungen geladen'};
  const reviewPages = {page:1,busy:false,done:false,seen:new Set(),rows:[],root:null};
  const pageSize = 50;
  function concertAnswer(item, id, label) {
    const answers=Array.isArray(item.additional_ratings)?item.additional_ratings:[];
    const answer=answers.find(answer=>{
      const question=answer.question || {};
      if(Number(question.private)===1)return false;
      return Number(question.id)===id || String(question.public_label || answer.name || '').trim()===label;
    });
    return answer && typeof answer.rating==='string'?answer.rating.trim():'';
  }
  function concertCity(item) {
    const place=concertAnswer(item,9045,'Stadt/Ort');
    // Normalize this known city/venue answer without splitting city names containing a slash.
    return /^Hameln\s*\/\s*Rattenfängerhalle$/i.test(place)?'Hameln':place;
  }
  function visibleReview(entry) {
    const item=entry?._source, type=entry?._type;
    if(!item || !['store_review','store_third_party_review'].includes(type)) return null;
    const rating=Number(item.rating), date=String(item.date_created || '');
    if(!Number.isInteger(rating) || rating<3 || rating>5 || !/^\d{4}-\d{2}-\d{2}/.test(date)) return null;
    const id=String(entry._id || type+'-'+item._id);
    return {id,rating,date,concertPlace:concertCity(item),concertDate:concertAnswer(item,9046,'Datum'),author:String(item.author || ''),comments:String(item.comments || ''),imported:type==='store_third_party_review',images:Array.isArray(item.images)?item.images:[]};
  }
  function reviewElement(tag, className, text) {
    const node=document.createElement(tag);node.className=className;
    if(text!==undefined)node.textContent=text;
    return node;
  }
  function reviewCard(item) {
    const card=reviewElement('article','tdt-review-card');card.setAttribute('role','article');card.dataset.reviewId=item.id;
    const top=reviewElement('div','tdt-review-card-top');
    top.append(reviewElement('strong','tdt-review-author',item.author));
    const date=reviewElement('time','tdt-review-date');date.dateTime=item.date.slice(0,10);
    date.textContent=new Intl.DateTimeFormat(da?'da-DK':en?'en-GB':'de-DE',{day:'2-digit',month:'2-digit',year:'numeric',timeZone:'UTC'}).format(new Date(item.date.slice(0,10)+'T12:00:00Z'));
    top.append(date);card.append(top);
    const stars=reviewElement('div','R-RatingStars__stars tdt-review-card-stars','★'.repeat(item.rating)+'☆'.repeat(5-item.rating));
    stars.title=item.rating+' Stars';stars.setAttribute('aria-label',item.rating+' / 5');card.append(stars);
    if(item.concertPlace || item.concertDate){
      const place=reviewElement('p','tdt-review-concert-place');
      place.append(reviewElement('span','tdt-review-concert-label',da?'Koncert: ':en?'Concert: ':'Konzert: '));
      place.append(document.createTextNode([item.concertDate,item.concertPlace].filter(Boolean).join(' · ')));
      card.append(place);
    }
    if(item.comments)card.append(reviewElement('p','tdt-review-text',item.comments));
    const photos=item.images.filter(photo=>photo.status==='active' && /^[a-zA-Z0-9_.-]+\.(?:jpe?g|png|webp)$/i.test(photo.image || ''));
    if(photos.length){
      const gallery=reviewElement('div','tdt-review-photos');
      photos.forEach(photo=>{
        const source='https://s3-eu-west-1.amazonaws.com/reviewscouk/assets/'+photo.image;
        const frame=reviewElement('div','tdt-review-photo');
        const img=document.createElement('img');img.src='https://media.reviews.co.uk/resize/create?format=jpg&height=0&width=200&src='+encodeURIComponent(source);img.alt=pagingCopy.photo;img.loading='lazy';img.width=100;img.height=100;
        frame.append(img);gallery.append(frame);
      });card.append(gallery);
    }
    if(item.imported)card.append(reviewElement('small','tdt-review-source',pagingCopy.imported));
    return card;
  }
  function loadReviews(panel) {
    if(reviewPages.root || !panel.querySelector('.FloatingPanel__content'))return;
    const root=reviewElement('section','tdt-review-timeline');
    root.append(reviewElement('p','tdt-review-sort',pagingCopy.newest));
    const list=reviewElement('div','tdt-review-list');
    const status=reviewElement('p','tdt-review-load-status');status.setAttribute('role','status');
    const more=reviewElement('button','tdt-review-more',pagingCopy.more);more.type='button';
    more.addEventListener('click',()=>loadReviewPage(panel));
    root.append(list,status,more);reviewPages.root=root;
    panel.querySelector('.FloatingPanel__content').append(root);
    loadReviewPage(panel);
  }
  async function loadReviewPage(panel) {
    if(reviewPages.busy || reviewPages.done)return;
    reviewPages.busy=true;
    const root=reviewPages.root, status=root.querySelector('.tdt-review-load-status'), more=root.querySelector('.tdt-review-more');
    more.disabled=true;more.textContent=pagingCopy.loading;status.textContent='';root.setAttribute('aria-busy','true');
    const controller=new AbortController(), timeout=setTimeout(()=>controller.abort(),12000);
    try {
      // Public endpoint used by the provider's widget; no private API key or product reviews.
      const url=new URL('https://api.reviews.io/timeline/data');
      url.search=new URLSearchParams({store:'dark-tenor',type:'store_review',include_local_reviews:'true',include_product_reviews:'false',sort:'date_desc',per_page:String(pageSize),page:String(reviewPages.page)}).toString();
      const response=await fetch(url.href,{signal:controller.signal,credentials:'omit'});
      if(!response.ok)throw new Error('Review request failed');
      const data=await response.json();if(!Array.isArray(data.timeline))throw new Error('Invalid review response');
      const additions=[];
      data.timeline.forEach(entry=>{const item=visibleReview(entry);if(item && !reviewPages.seen.has(item.id)){reviewPages.seen.add(item.id);additions.push(item);}});
      reviewPages.rows.push(...additions);
      reviewPages.rows.sort((a,b)=>b.date.localeCompare(a.date)||a.id.localeCompare(b.id));
      const list=root.querySelector('.tdt-review-list');
      // Reuse existing nodes so photos and focus survive additional pages.
      const cards=new Map([...list.children].map(card=>[card.dataset.reviewId,card]));
      reviewPages.rows.forEach(item=>list.append(cards.get(item.id)||reviewCard(item)));
      panel.querySelector('.FloatingPanel__content').classList.add('tdt-reviews-paginated');
      reviewPages.page++;
      reviewPages.done=data.timeline.length<pageSize;
      status.textContent=reviewPages.rows.length?reviewPages.rows.length+' '+pagingCopy.loaded:pagingCopy.empty;
      more.textContent=pagingCopy.more;more.hidden=reviewPages.done;
    } catch(error) {
      status.textContent=pagingCopy.error;more.textContent=pagingCopy.retry;
    } finally {
      clearTimeout(timeout);reviewPages.busy=false;more.disabled=false;root.setAttribute('aria-busy','false');
    }
  }
  function queue(){if(!scheduled){scheduled=true;requestAnimationFrame(enhance);}}
  function close(){const button=host.querySelector('.FloatingPanel.isActive .R-IconButton--close');if(button)button.click();}
  host.querySelector('.tdt-reviews-backdrop').addEventListener('click',close);
  document.addEventListener('keydown',e=>{if(!wasOpen)return;if(e.key==='Escape'){e.preventDefault();close();}if(e.key==='Tab'){const list=[...host.querySelectorAll('.FloatingPanel [tabindex="0"],.FloatingPanel a[href],.FloatingPanel button')].filter(el=>el.getClientRects().length);if(!list.length)return;const first=list[0],last=list[list.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}});
  new MutationObserver(queue).observe(host,{childList:true,subtree:true,attributes:true,attributeFilter:['class','title']});
  const content=document.getElementById('MainContent');if(content)new MutationObserver(queue).observe(content,{childList:true,subtree:true});
  enhance();
  const script=document.createElement('script');script.src='https://widget.reviews.io/modern-widgets/floating.js';script.async=true;document.body.append(script);
})();





